import { DesignData, MediaElement } from 'editor/src/store/design/types';
import { getAdvPersoDataFromElement } from 'editor/src/store/plugins/utils/advPersoUtils';

function sharedId(element: MediaElement): string | undefined {
  if (element.type === 'text') {
    return element.extra.sharedFieldId;
  }
  return element.type === 'image' ? getAdvPersoDataFromElement(element)?.linkGroupId : undefined;
}

/** Whether a shared value (a text's shared field, a collection layer's link group) also sits on a
 *  layer the layout does not manage, such as a date in a slot that the cover page shows too.
 *  Such a value is one for every product, not per product. */
function isSharedOutsideLayout(designData: DesignData, id: string, layoutId: string): boolean {
  return designData.spreads.some((spread) =>
    spread.pages.some((page) =>
      page.groups.media?.some((element) => sharedId(element) === id && element.slotFrame?.layoutId !== layoutId),
    ),
  );
}

export default isSharedOutsideLayout;
